import Modal from "@/components/Modal";
import PhotoUpload from "@/components/PhotoUpload";
import CategoryPicker from "@/components/CategoryPicker";
import { Save, Search } from "lucide-react";
import { useState } from "react";
import { api } from "@/lib/api";

export default function BusinessFormModal({ open, onClose, onSubmit }) {
  const [form, setForm] = useState({
    owner_id: "", owner_label: "", name: "", category: "", description: "", address: "",
    whatsapp: "", photo_path: "", lat: null, lng: null,
  });
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);

  const search = async (val) => {
    setQ(val);
    if (!val || val.length < 2) { setResults([]); return; }
    try { const { data } = await api.get("/admin/members-lookup", { params: { q: val } }); setResults(data); }
    catch { setResults([]); }
  };

  const save = () => {
    if (!form.owner_id) return alert("Pilih pemilik dulu");
    if (!form.name || !form.description || !form.address || !form.photo_path) return alert("Nama, deskripsi, alamat & foto wajib");
    onSubmit(form);
  };

  if (!open) return null;
  return (
    <Modal open={open} onClose={onClose} title="Tambah Bisnis Baru" testId="business-modal"
      footer={<>
        <button onClick={onClose} className="btn-outline flex-1" data-testid="cancel-business-btn">Batal</button>
        <button onClick={save} className="btn-primary flex-1" data-testid="save-business-btn"><Save size={16}/> Buat Bisnis</button>
      </>}>
      <div className="space-y-3">
        <div>
          <label className="text-sm font-medium">Pemilik * <span className="text-xs text-bizma-subtext font-normal">(cari min 2 karakter)</span></label>
          <div className="relative mt-2">
            <input value={form.owner_id ? form.owner_label : q}
              onChange={(e) => { setForm({ ...form, owner_id: "", owner_label: "" }); search(e.target.value); }}
              placeholder="Ketik nama/email anggota..." className="input-bizma pr-8" data-testid="new-business-owner-search"/>
            <Search size={14} className="absolute right-3 top-1/2 -translate-y-1/2 text-bizma-subtext"/>
          </div>
          {results.length > 0 && !form.owner_id && (
            <div className="mt-2 border border-bizma-border rounded-2xl max-h-48 overflow-y-auto divide-y divide-bizma-border">
              {results.map((o) => (
                <button key={o.user_id} type="button"
                  onClick={() => { setForm({ ...form, owner_id: o.user_id, owner_label: `${o.name} (${o.email})` }); setResults([]); setQ(""); }}
                  className="w-full text-left px-3 py-2 hover:bg-bizma-muted text-sm" data-testid={`owner-option-${o.user_id}`}>
                  <div className="font-medium">{o.name}</div>
                  <div className="text-xs text-bizma-subtext">{o.email}{o.username && ` · @${o.username}`}</div>
                </button>
              ))}
            </div>
          )}
        </div>
        <F label="Nama Bisnis *"><input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="input-bizma" data-testid="new-business-name"/></F>
        <F label="Kategori"><CategoryPicker value={form.category} onChange={(v) => setForm({ ...form, category: v })} testId="new-business-category"/></F>
        <F label="Alamat *"><input value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} className="input-bizma" data-testid="new-business-address"/></F>
        <F label="Deskripsi *"><textarea rows={3} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="input-bizma h-auto py-3" data-testid="new-business-desc"/></F>
        <F label="WhatsApp Bisnis (opsional)"><input value={form.whatsapp} onChange={(e) => setForm({ ...form, whatsapp: e.target.value })} placeholder="Kosongkan untuk pakai WA owner" className="input-bizma" data-testid="new-business-wa"/></F>
        <F label="Foto Bisnis *"><PhotoUpload value={form.photo_path} onChange={(p) => setForm({ ...form, photo_path: p })} shape="square" testId="new-business-photo"/></F>
      </div>
    </Modal>
  );
}

function F({ label, children }) {
  return <div><label className="text-sm font-medium">{label}</label><div className="mt-2">{children}</div></div>;
}
